import cn from 'classnames';
import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { mutate } from 'swr';

import { ClockCircleFilled } from '@ant-design/icons';

import { OverlayMessageProps } from '~components/ui/OverlayMessage/OverlayMessage';
import useGlobalState from '~utils/hooks/useGlobalState';
import usePurchase from '~utils/hooks/usePurchase';
import parseDuration from '~utils/parseDuration';

import s from './RemainingTime.module.css';

const RemainingTime = () => {
  const { query, replace, asPath } = useRouter();
  const [, setOverlayProps] = useGlobalState<OverlayMessageProps>('OverlayMessage');
  const [remainingTime, setRemainingTime] = useGlobalState<number | undefined>('BuyRemainingTime');
  const { expDate, resetPurchase, processingPurchase } = usePurchase();
  useEffect(() => {
    if (expDate) {
      setRemainingTime(dayjs(expDate).diff(dayjs(), 'seconds'));
    }
  }, [expDate]);

  useEffect(() => {
    if (remainingTime !== undefined && expDate !== undefined) {
      if (remainingTime > 0) {
        setTimeout(() => {
          //setRemainingTime(remainingTime - 1);
          setRemainingTime(dayjs(expDate).diff(dayjs(), 'seconds'));
        }, 1000);
      } else {
        setRemainingTime(undefined);
        resetPurchase();
        replace(asPath.replace('?step=pago', '?step=inicio'), undefined, {
          shallow: true,
        }).then(() => {
          setOverlayProps({
            title: 'Tu sesión expiró',
            message: 'Has alcanzado el limite de tiempo que tienes para realizar la compra.',
            icon: <ClockCircleFilled className="text-5xl" />,
            visible: true,
            children: (
              <button
                className="btn text-black"
                onClick={() => {
                  setOverlayProps({});
                }}
              >
                Intentar de nuevo
              </button>
            ),
          });
        });
        mutate(`/shows/seats/${query.session}`);
      }
    }
  }, [remainingTime]);
  if (!expDate || !remainingTime || processingPurchase) return null;
  return (
    <div
      className={cn(s.root, {
        [s.warning]: remainingTime <= 30 && remainingTime > 10,
        [s.danger]: remainingTime <= 10,
      })}
    >
      <div>
        <span className="callout block">Tiempo restante para completar tu compra:</span>
        <span className="h2">
          {(() => {
            if (remainingTime) {
              const result = parseDuration(remainingTime);
              const minutes = `${result.minutes}`.padStart(2, '0');
              const seconds = `${result.seconds}`.padStart(2, '0');
              return `${minutes}:${seconds}`;
            }
          })()}
        </span>
      </div>
    </div>
  );
};

export default RemainingTime;
